<template>
    <div class="add-to-cart w100p">
        <button :class="[classes, color]" @click.prevent="addToCart" :disabled="!product || soldOut || isPreorderableEbook">
            <img src="/images/icon-cart-white.png" alt="cart icon">
            <span v-if="showAddText">
                {{ isPreorder ? label("shop.product.detail.preorder") : (soldOut ? 'Uitverkocht' : label("shop.product.detail.add_to_order"))  }}
            </span>
        </button>

        <div class="modal-fancybox" :id="modalId" style="max-width: 700px;">
            <div class="col-12 centerText">
                <p v-if="errorMessage" v-html="errorMessage" class="paragraph redColor col-12 ml5 mt20"></p>
                <p v-html="feedbackMessage" class="paragraph col-12 ml5 mt20 mb30"></p>
                <div class="button-group-cart">
                    <a v-show="showButtons" @click.prevent="continueShopping" class="button big blue mr5 ml5 mb5"
                       v-text="label('shop.cart.continue_shopping')"></a>
                    <a v-show="showButtons" @click.prevent="goToCart" class="button big green mr5 ml5 mb5"
                       v-text="label('shop.cart.go_to_cart')"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import addsToCart from "../mixins/addToCart";
import {forEach} from 'lodash';
import Quantity from "./Quantity";
import translations from "../mixins/translations";

export default {
    name: "add-to-cart",
    components: {
        Quantity,
    },
    mixins: [
        addsToCart,
        translations,
    ],
    props: {
        routeCart: {
            required: false,
            type: String,
            default: null,
        },
        currency: {
            required: false,
            type: String,
            default: 'EUR'
        },
        modalId: {
            required: false,
            type: String,
            default: "add-to-cart-modal"
        },
        modalShow: {
            required: false,
            type: Boolean,
            default: true,
        },
        showAddText: {
            required: false,
            type: Boolean,
            default: true,
        },
        classes: {
            required: false,
            type: String,
            default: "button withIcon w100p floatNone"
        },
        availability: {
            required: false,
            type: Object | false,
            default: false,
        },
        product: {
            required: false,
            type: Object | null,
            default: null,
        }
    },
    data() {
        return {
            currentLang: {},
            showButtons: false,
        }
    },
    methods: {
        changeLang() {
            forEach(this.lang, (value, key) => {
                this.currentLang[key] = value;
            })
        },
        missingProductId() {
            this.errorMessage = '### MISSING PRODUCT ###';
            this.showButtons = false;
        },
        afterSuccessFullSubmission() {
            // Actions inside store!!
            this.showButtons = true;
            this.openModal();

            if(window.seo_enabled === 1) {
                trackAddToCartGoogle(this.product, 1);
            }
        },
        onError() {
            this.showButtons = false;
        },
        openModal() {
            if (this.modalShow === false) {
                // window.flash(this.feedbackMessage, 'success')
            } else {
                $.fancybox.open({
                    src: `#${this.modalId}`,
                });
            }
        },
        closeModal() {
            $.fancybox.close({
                src: `#${this.modalId}`,
            });
        },
        continueShopping() {
            this.closeModal();
        },
        goToCart() {
            if (this.routeCart) {
                window.location = this.routeCart;
            }

            this.closeModal();
        }
    },
    computed: {
        isPreorder() {
            return this.availability && this.availability.availability === 'soon';
        },
        color() {
            return this.isPreorder ? 'yellow' : (this.soldOut ? 'red' : 'green');
        },
        soldOut(){
            return this.availability && this.availability.availability === 'not-available';
        },
        isPreorderableEbook(){
            return this.product && this.product?.is_ebook && this.availability && this.availability.availability === 'soon';
        }
    },
    watch: {},
    mounted() {
        this.changeLang();
    }
}
</script>
